<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="ownerId" :options="owners" placeholder="placeholder.owner" @change="clear"/>
      </template>
      <template #extra>
        <vxe-button content="button.taken" icon="vxe-icon-search" status="primary" @click="pickUp"/>
        <vxe-button content="button.clear" icon="vxe-icon-cut" status="danger" @click="clear"/>
        <vxe-button content="button.save" icon="vxe-icon-save" status="primary" @click="save"/>
      </template>
      <vxe-table ref="table" :data="data" :edit-rules="editRules" :editConfig="{}" :loading="loading" keep-source>
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="invQuantity" title="business.label.invQuantity"/>
        <vxe-column field="quantity" title="business.label.quantity"/>
        <vxe-column field="inventoryLimit.lowerBound" title="business.label.lowerBound"/>
        <vxe-column field="inventoryLimit.upperBound" title="business.label.upperBound"/>
        <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom"/>
        <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore"/>
        <vxe-column :editRender="{name:'VxeNumberInput',props:{min:0}}" field="obtainedQuantity" title="title.replenishmentQuantity"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <ActiveReplenishmentModal ref="modal" @change="change"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import api from '@/api'
import ActiveReplenishmentModal from '@/views/modal/ActiveReplenishmentModal.vue'
import { getOptions } from '@/utils/util'

export default {
  components: { ActiveReplenishmentModal },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      owners: [],
      ownerId: undefined,
      editRules: {
        obtainedQuantity: [{ required: true, type: 'number', min: 1, message: '补货数量需大于0' }]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    })
  },
  methods: {
    change(values) {
      this.data = values
    },
    pickUp() {
      if (!this.ownerId) {
        return this.$message.warning('请先选择货主')
      }
      this.$refs.modal.open({ 'owner.id': this.ownerId })
    },
    clear() {
      this.data = []
    },
    save() {
      this.loading = true
      const order = {
        warehouse: { id: this.warehouse.id },
        orderType: { id: this.queryParam.value.business.orderTypeId },
        dataSource: 4,
        owner: { id: this.ownerId },
        details: this.data.map(item => {
          return {
            item: { id: item.item.id },
            pack: { id: item.pack.id },
            storageRoom: { id: item.targetStorageRoom.id },
            logicalStore: { id: item.logicalStore.id },
            invoiceQuantity: item.obtainedQuantity
          }
        })
      }
      post(api.replenishingReplenish, { type: 'initiativeReplenisher' }, order).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.data = []
        }
      }).finally(() => this.loading = false)
    },
    remove(row) {
      this.$refs.table._remove(row)
    }
  }
}
</script>